import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import Icon from '~/components/Icon/Icon';
import { userStore } from '~/stores/UserStore';

import styles from './Balance.module.scss';

const Balance = () => {
  const { t } = useTranslation();

  const image = (
    <svg
      viewBox="0 0 155 74"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={styles.balance_wrapper__image}
    >
      <g clipPath="url(#clip0_33406_543419)">
        <path
          d="M119.65 66.7217C100.205 66.7217 84.2175 61.9396 84.2175 52.7709C84.2175 40.6565 77.1587 39.4287 128.152 39.4287C158.674 39.4287 155.003 33.9676 155.003 52.7709C155.003 61.9396 139.096 66.7217 119.65 66.7217Z"
          fill="var(--brandAtom900, #182D48)"
        />
        <path
          d="M119.65 66.7217C100.205 66.7217 84.2175 61.9396 84.2175 52.7709C84.2175 40.6565 77.1587 39.4287 128.152 39.4287C158.674 39.4287 155.003 33.9676 155.003 52.7709C155.003 61.9396 139.096 66.7217 119.65 66.7217Z"
          fill="black"
          fillOpacity="0.5"
        />
        <ellipse
          cx="119.606"
          cy="41.851"
          rx="12.7377"
          ry="35.3937"
          transform="rotate(90 119.606 41.851)"
          fill="var(--primaryButtonHover, #314c71)"
        />
        <path
          d="M109.876 42.8199C109.876 43.6211 110.275 44.3239 111.074 44.9283C111.873 45.5327 113.039 46.0106 114.573 46.362L114.573 49.7353C111.154 49.2434 108.486 48.379 106.569 47.1421C104.683 45.9192 103.741 44.4855 103.741 42.841C103.741 41.1543 104.763 39.6715 106.808 38.3924C108.885 37.1274 111.649 36.2489 115.1 35.7569L115.1 33.9648L119.078 33.9648L119.078 35.4196C119.845 35.3915 120.42 35.3774 120.803 35.3774C121.251 35.3774 121.858 35.3915 122.625 35.4196L122.625 33.9648L126.603 33.9648L126.603 35.778C130.054 36.27 132.802 37.1485 134.847 38.4135C136.892 39.6925 137.914 41.1684 137.914 42.841C137.914 44.4855 136.955 45.9192 135.038 47.1421C133.121 48.379 130.469 49.2434 127.082 49.7353L127.082 46.362C128.616 46.0106 129.766 45.5327 130.533 44.9283C131.332 44.3239 131.731 43.6211 131.731 42.8199C131.731 41.9625 131.284 41.1965 130.389 40.5218C129.495 39.8612 128.232 39.3482 126.603 38.9827L126.603 43.0308L122.625 43.0308L122.625 38.4556C121.858 38.4275 121.251 38.4135 120.803 38.4135C120.42 38.4135 119.845 38.4275 119.078 38.4556L119.078 43.0308L115.1 43.0308L115.1 38.9616C113.47 39.3271 112.192 39.8472 111.266 40.5218C110.339 41.1965 109.876 41.9625 109.876 42.8199Z"
          fill="var(--brandAtom50, #FDF4F3)"
        />
        <path
          d="M118.385 54.588C128.637 46.3388 114.113 40.2328 105.57 38.2109C98.0438 40.8394 82.7472 46.0962 81.7708 46.0962C80.7944 46.0962 85.0274 62.8776 85.4342 69.7519L118.385 66.7191V54.588Z"
          fill="black"
          fillOpacity="0.5"
        />
        <path
          d="M21.9677 71.5721C23.1862 74.6049 70.1759 71.8675 74.4475 70.359L63.4631 61.8672C63.4631 61.8672 21.3503 64.0299 21.9677 71.5721Z"
          fill="black"
          fillOpacity="0.5"
        />
        <path
          d="M106.181 35.141C106.181 54.469 95.9335 70.1374 83.2928 70.1374C66.5908 70.1374 61.0234 76.1727 61.0234 25.4869C61.0234 -3.47418 69.0656 0.144672 83.2928 0.144672C95.9335 0.144672 106.181 15.8131 106.181 35.141Z"
          fill="var(--brandAtom900, #182D48)"
        />
        <path
          d="M106.181 35.141C106.181 54.469 95.9335 70.1374 83.2928 70.1374C66.5908 70.1374 61.0234 76.1727 61.0234 25.4869C61.0234 -3.47418 69.0656 0.144672 83.2928 0.144672C95.9335 0.144672 106.181 15.8131 106.181 35.141Z"
          fill="black"
          fillOpacity="0.5"
        />
        <ellipse
          cx="71.3991"
          cy="35.1803"
          rx="22.5787"
          ry="35.1803"
          fill="var(--primaryButtonHover, #314c71)"
        />
        <path
          d="M82.9902 40.5854C82.9902 41.9792 82.6269 43.2926 81.9003 44.5255C81.2007 45.7317 80.1512 46.7369 78.7518 47.541C77.3794 48.3183 75.7513 48.774 73.8675 48.908V52.1647H71.2841V48.8678C68.5931 48.6266 66.4268 47.8224 64.7852 46.4554C63.1437 45.0616 62.296 43.1853 62.2422 40.8266H68.2971C68.4585 42.7565 69.4542 43.9225 71.2841 44.3245V36.6452C69.3466 36.1627 67.7858 35.6802 66.6017 35.1977C65.4176 34.7153 64.395 33.9379 63.5339 32.8658C62.6728 31.7936 62.2422 30.3328 62.2422 28.4833C62.2422 26.1514 63.0764 24.2483 64.7449 22.7741C66.4402 21.2998 68.62 20.4555 71.2841 20.2411V16.9844H73.8675V20.2411C76.451 20.4555 78.5096 21.2328 80.0435 22.573C81.6043 23.9132 82.4789 25.7627 82.6673 28.1215H76.5721C76.4913 27.3441 76.2088 26.674 75.7244 26.1112C75.2669 25.5215 74.6479 25.106 73.8675 24.8648V32.4637C75.8858 32.973 77.4736 33.4689 78.6307 33.9513C79.8148 34.407 80.8374 35.1709 81.6985 36.2431C82.5597 37.2885 82.9902 38.7359 82.9902 40.5854ZM68.1356 28.2019C68.1356 29.0864 68.4047 29.8101 68.9429 30.373C69.4811 30.9091 70.2615 31.3514 71.2841 31.6998V24.7442C70.3154 24.8782 69.5484 25.24 68.9833 25.8297C68.4182 26.4194 68.1356 27.2101 68.1356 28.2019ZM73.8675 44.4049C74.8901 44.2173 75.684 43.8018 76.2491 43.1585C76.8412 42.5152 77.1372 41.7379 77.1372 40.8266C77.1372 39.9421 76.8546 39.2317 76.2895 38.6957C75.7244 38.1596 74.9171 37.7173 73.8675 37.3689V44.4049Z"
          fill="var(--brandAtom50, #FDF4F3)"
        />
        <mask
          id="mask0_33406_543419"
          style={{ 'mask-type': 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="48"
          y="0"
          width="46"
          height="71"
        >
          <ellipse
            cx="71.3991"
            cy="35.1803"
            rx="22.5787"
            ry="35.1803"
            fill="var(--primaryButtonHover, #314c71)"
          />
        </mask>
        <g mask="url(#mask0_33406_543419)">
          <ellipse
            cx="60.4151"
            cy="46.0978"
            rx="20.1378"
            ry="32.7541"
            fill="black"
            fillOpacity="0.5"
          />
          <ellipse
            cx="60.4151"
            cy="46.0978"
            rx="20.1378"
            ry="32.7541"
            fill="black"
            fillOpacity="0.5"
          />
        </g>
        <path
          d="M56.2036 54.8091C44.6431 70.4766 27.12 77.2351 17.0646 69.9048C3.77866 60.2193 -4.25991 61.8831 26.0565 20.7966C43.3788 -2.67949 47.6116 4.91763 58.9289 13.1679C68.9843 20.4983 67.7641 39.1417 56.2036 54.8091Z"
          fill="var(--seed700AccCTA, #fb8b4b)"
        />
        <ellipse
          cx="22.5312"
          cy="35.2551"
          rx="22.5312"
          ry="35.2551"
          transform="matrix(0.808072 0.589083 -0.593734 0.804662 30.8789 -7.27734)"
          fill="var(--seed700AccCTA, #fb8b4b)"
        />
        <ellipse
          cx="22.5312"
          cy="35.2551"
          rx="22.5312"
          ry="35.2551"
          transform="matrix(0.808072 0.589083 -0.593734 0.804662 30.8789 -7.27734)"
          fill="var(--seed00, #ffffff)"
          fillOpacity="0.7"
        />
        <path
          d="M42.3884 38.0931C41.4714 39.3621 40.2594 40.3705 38.7526 41.1184C37.2719 41.8798 35.5423 42.2177 33.5639 42.1324C31.6117 42.0604 29.5137 41.4472 27.27 40.2927L22.6913 37.9366L16.1082 47.0463L10.6294 44.2271L27.7748 20.5013L37.8323 25.6765C39.9456 26.7639 41.5165 28.0074 42.5451 29.4071C43.5736 30.8068 44.052 32.2498 43.9801 33.7361C43.9343 35.2358 43.4037 36.6881 42.3884 38.0931ZM29.8109 36.3308C31.324 37.1095 32.6588 37.3921 33.8151 37.1789C34.9877 36.9429 35.967 36.2811 36.7531 35.1934C38.4234 32.882 37.7715 30.9611 34.7973 29.4307L30.4534 27.1955L25.467 34.0956L29.8109 36.3308Z"
          fill="var(--seed00, #ffffff)"
        />
      </g>
      <defs>
        <clipPath id="clip0_33406_543419">
          <rect width="155" height="74" fill="var(--seed00, #ffffff)" />
        </clipPath>
      </defs>
    </svg>
  );

  return (
    <div className={styles.balance_wrapper}>
      <h4 className={styles.balance_wrapper__title}>
        {t('loyalty:balance:yourWallet')}
      </h4>
      {image}
      <div className={styles.balance_wrapper__coins}>
        <Icon type="coins" size={32} />
        <span>{userStore.loyaltyPointsStore.loyaltyPoints}</span>
      </div>
    </div>
  );
};

export default observer(Balance);
